import { createStyles, makeStyles } from '@material-ui/core';

export default makeStyles((theme) =>
  createStyles({
    groupCell: {
      cursor: 'pointer',
      '& strong': {
        display: 'none',
      },
    },
    groupText: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      gap: 1,
    },
    checkbox: {
      padding: 8,
    },
    groupTitle: {
      fontWeight: 'bold',
      marginRight: '4px',
    },
  })
);
